import React from "react";
import { useNavigate } from "react-router-dom";

const CreateListingPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: "20px", fontFamily: "'Roboto', sans-serif" }}>
      <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
        Choose Your Listing Type
      </h1>
      <p style={{ textAlign: "center", marginBottom: "30px", fontSize: "1.1em" }}>
        Select the appropriate option below to create a new listing. Hover over
        each option to see tips on which to use.
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
        }}
      >
        <button
          onClick={() => navigate("/create-single-listing")}
          style={listingButtonStyle}
          title="Use this to create a single car listing."
        >
          Create Single Listing
        </button>
        <button
          onClick={() => navigate("/create-multiple-listings")}
          style={listingButtonStyle}
          title="Use this to upload multiple listings at once."
        >
          Create Multiple Listings
        </button>
        <button
          onClick={() => navigate("/create-private-batch")}
          style={listingButtonStyle}
          title="Use this to create a private batch for select investors."
        >
          Create a Private Batch
        </button>
        <button
          onClick={() => navigate("/create-fleet")}
          style={listingButtonStyle}
          title="Use this to create a fleet of vehicles for business purposes."
        >
          Create-A-Fleet
        </button>
      </div>
    </div>
  );
};

const listingButtonStyle = {
  background: "#007bff",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  padding: "15px 25px",
  fontSize: "1.2em",
  fontWeight: "bold",
  cursor: "pointer",
  width: "300px",
  textAlign: "center",
  transition: "transform 0.2s, background-color 0.2s",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
};

listingButtonStyle["hover"] = {
  background: "#0056b3",
  transform: "scale(1.05)",
};

export default CreateListingPage;
